import styled from 'styled-components';

export const LineDivider = styled.hr`
    width: 80vw; 
    border: 1px solid #dfdfdf;
`;